<template>
  <div
    class="calllog__item"
    :class="[
      {
        'calllog__item--active': isSelected,
      },
    ]"
    @click="handleFetchHIstory(log.phone_number)"
  >
    <bv-avatar :name="log.phone_number" />
    <div class="calllog__content">
      <div class="calllog__group">
        <h4 class="calllog__title">{{ log.name || log.phone_number }}</h4>
        <span class="calllog__time">{{ formatCallTime(log.call_time) }}</span>
      </div>
      <div class="calllog__info">
        <div class="calllog__icon">
          <img
            v-if="log.direction === 'outbound' && log.status !== 'missed'"
            src="@/assets/images/icons/call-outgoing.svg"
          />
          <img
            v-else-if="log.direction === 'inbound' && log.status !== 'missed'"
            src="@/assets/images/icons/call-incoming.svg"
          />
          <img
            v-else-if="log.status === 'missed'"
            src="@/assets/images/icons/call-slash.svg"
          />
        </div>
        <span class="calllog__status">{{ contactStatus }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'CallLogItem',
    props: {
      log: {
        type: Object,
        required: true,
      },
    },
    computed: {
      isSelected() {
        return this.$route.params.number === this.log.phone_number;
      },
      contactStatus() {
        if (this.log.direction === 'outbound' && this.log.status !== 'missed') {
          return this.$t('call_center.call_status.outgoing_call');
        } else if (this.log.direction === 'inbound' && this.log.status !== 'missed') {
          return this.$t('call_center.call_status.incoming_call');
        } else {
          return this.$t('call_center.call_status.missed_call');
        }
      },
    },
    methods: {
      formatCallTime(callTime) {
        const now = moment();
        const callMoment = moment(callTime);

        if (now.isSame(callMoment, 'day')) {
          return this.$t('call_center.call_time.today');
        } else if (now.subtract(1, 'days').isSame(callMoment, 'day')) {
          return this.$t('call_center.call_time.yesterday');
        } else {
          return callMoment.format('MMM D, YYYY, h:mm A');
        }
      },
      async handleFetchHIstory(phoneNumber) {
        this.$router.push({
          name: 'call-log-show',
          params: {
            number: phoneNumber,
          },
          query: {
            id: this.log.contact_id || undefined,
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .calllog {
    &__item {
      display: flex;
      gap: 8px;
      align-items: center;
      padding: 8px;
      border-radius: 8px;
      border: 1px solid var(--gray100);
      background-color: var(--shadesWhite);
      cursor: pointer;
      transition:
        border-color 300ms ease-in-out,
        background-color 300ms ease-in-out,
        box-shadow 300ms ease-in-out;
      &--active {
        border-color: var(--color-base-500, #095ea6);
        background-color: var(--color-base-50, #eff7fe);
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
      }
    }

    &__content {
      flex-grow: 1;
    }
    &__group {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-block-end: 8px;
    }
    &__title {
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      color: var(--gray900);
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 112px;
    }
    &__time {
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: var(--gray500);
    }

    &__info {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    &__icon {
      line-height: 0;
    }

    &__status {
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: var(--gray500);
    }
  }
</style>
